import React, { useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";

// project-import
import LoginForm from "./LoginForm";

const ModalLogin = ({ show, onCloseModalLogin, title = "Login" }) => {
  // React hook initialization
  const textareaRef = useRef(null);

  useEffect(() => {
    if (show) {
      setTimeout(() => {
        const element = textareaRef.current;
        if (element) {
          element.focus();
        }
      }, 400);
    }
  }, [show]);

  // Constant function
  const renderContent = () => {
    return <LoginForm hideHeader={true} onClose={onCloseModalLogin} />;
  };

  return (
    <Modal
      className="rounded-lg"
      show={show}
      onHide={onCloseModalLogin}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      size="md-down"
    >
      <Modal.Header closeButton className="px-5 border-0">
        <Modal.Title as={"h5"} className="mb-0">
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-5 pb-4">{renderContent()}</Modal.Body>
    </Modal>
  );
};

export default ModalLogin;
